function validateCustomAvatarProperty(payload: any){
    return payload && payload.customIVA
}

function validateAvatarIsCustom(newAvatar: any, _settings: any){
    //@ts-ignore
    return !_settings.textConstants.payloadDefaultIvaValue.includes(newAvatar) &&
        newAvatar !== "";
}

function getCustomAvatar(payloadBase: any){
    //if payload exists in the state
    if(payloadBase && payloadBase.customIVA){
        //  if payload contains data for IVA customization
        if (payloadBase.customIVA.IVAAvatar){
            let newAvatar = payloadBase.customIVA.IVAAvatar;
            //  ALIGHT-4312 Custom Avatar Webdav URL Not Recognized
            if (newAvatar.indexOf("<") == 0){
                //  parse just the part that we need from the img dom being sent
                newAvatar = newAvatar.match(/(?:src=["'])(.*?)(?:["'])/i)[1]
            }
            return newAvatar;
        }
    }
    return "";
}

export{
    validateCustomAvatarProperty,
    validateAvatarIsCustom,
    getCustomAvatar
}


// WEBPACK FOOTER //
// ./modules/custom-avatar/custom-avatar-helper.ts